var $7ffda44237a758dd$exports = {};
const $7ffda44237a758dd$var$DOM = {
    positionBox: document.getElementById("position_box"),
    applyCareer: document.getElementById("apply_career"),
    showBtn: document.getElementById("show_btn")
};
let $7ffda44237a758dd$var$emptyArr = [];
let $7ffda44237a758dd$var$limit = 3;
let $7ffda44237a758dd$var$offset = 0;
let $7ffda44237a758dd$var$loaded = false; // ← prevents duplicate calls on re-observe
const $7ffda44237a758dd$var$career = (lim, off)=>{
    fetch(`${"https://qkkalabs.com"}/blog/api/open-positions?limit=${lim}&offset=${off}`).then((response)=>response.json()).then((data)=>{
        $7ffda44237a758dd$var$offset += 3;
        const results = data?.data?.results || [];
        $7ffda44237a758dd$var$emptyArr.push(...results);
        if ($7ffda44237a758dd$var$DOM.positionBox && results.length) {
            const fragment = document.createDocumentFragment();
            results.forEach((job)=>{
                const date = new Intl.DateTimeFormat("en-US").format(new Date(job.updated_at));
                const node = document.createElement("div");
                node.style.cursor = "pointer";
                node.classList.add("bg-violet");
                node.id = job.id;
                node.innerHTML = `
								<div class="col-span-1 w-full py-8 lg:px-14 px-4 border-b transition duration-150 ease-out hover:ease-in relative all_vaccancy">
									<div class="flex items-center justify-between">
										<div>
											<p class="xl:text-base text-sm Gilroy-semiBold opacity-80">${date}</p>
											<h3 class="xl:text-2xl text-lg Gilroy-semiBold capitalize text-white">${job.title}</h3>
											<p class="mt-4 lg:mt-0">
												<span class="text-base Gilroy-semiBold opacity-80">
													${job.max_experience !== "None" ? `${job.min_experience} - ${job.max_experience} Year Experience` : `${job.min_experience} + Year Experience`}
												</span>
											</p>
										</div>
										<div class="text-base capitalize Gilroy-Medium border-white border-1 border px-5 py-2">view detail</div>
									</div>
								</div>`;
                fragment.appendChild(node);
            });
            $7ffda44237a758dd$var$DOM.positionBox.appendChild(fragment);
            results.forEach((job)=>$7ffda44237a758dd$var$initializeEvent(job.id));
        }
        if ($7ffda44237a758dd$var$DOM.applyCareer) {
            $7ffda44237a758dd$var$DOM.applyCareer.classList.remove("block");
            $7ffda44237a758dd$var$DOM.applyCareer.classList.add("hidden");
        }
        if ($7ffda44237a758dd$var$DOM.showBtn && ($7ffda44237a758dd$var$emptyArr.length === 0 || $7ffda44237a758dd$var$emptyArr.length === data?.data?.count)) $7ffda44237a758dd$var$DOM.showBtn.classList.add("hidden");
    }).catch((err)=>console.error("career() error:", err));
};
function $7ffda44237a758dd$var$initializeEvent(id) {
    const viewEle = document.getElementById(id);
    if (viewEle) viewEle.onclick = ()=>{
        const url = new URL("/apply-career", window.location.origin);
        url.searchParams.append("id", id);
        window.open(url.href, "_self");
    };
}
// ✅ Trigger fetch only when #position_box scrolls into view
const $7ffda44237a758dd$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting && !$7ffda44237a758dd$var$loaded) {
            $7ffda44237a758dd$var$loaded = true;
            $7ffda44237a758dd$var$career($7ffda44237a758dd$var$limit, $7ffda44237a758dd$var$offset);
            $7ffda44237a758dd$var$observer.disconnect(); // ← stop observing after first load
        }
    });
}, {
    rootMargin: "100px"
}); // ← starts loading 100px before it's visible
if ($7ffda44237a758dd$var$DOM.positionBox) $7ffda44237a758dd$var$observer.observe($7ffda44237a758dd$var$DOM.positionBox);
window.BTNN = ()=>$7ffda44237a758dd$var$career($7ffda44237a758dd$var$limit, $7ffda44237a758dd$var$offset);


//# sourceMappingURL=careers.4d2f8d46.js.map
